import f from "../../atom/permission.mjs";
import U, { defaultUserState as P } from "../../atom/user.mjs";
import { useRecoilState as r } from "recoil";
const R = () => {
  const [n, a] = r(U), [t, i] = r(f), e = n || P, c = (s) => t.includes(s), l = (s) => s.some((o) => t.includes(o)), u = (s) => s.every((o) => t.includes(o)), m = (s) => e.roles.includes(s), d = (s) => e.roles.some((o) => s.includes(o)), p = (s) => e.roles.every((o) => s.includes(o)), S = e.openStates === 2, h = e.openStates === 1;
  return {
    /** 用户数据 */
    user: e,
    /** 权限列表 */
    permission: t,
    /** 判断用户是否拥有该角色 */
    hasRole: m,
    /** 判断用户是否具有角色列表中的某一项 */
    hasSomeRoles: d,
    /** 判断用户是否具有角色列表中的全部 */
    hasAllRoles: p,
    /** 设置权限 */
    setPermission: i,
    /** 设置角色 */
    setUser: a,
    /** 判断用户是否具有某权限 */
    hasPermission: c,
    /** 判断用户是否具有权限列表中的某一项 */
    hasSomePermissions: l,
    /** 判断用户是否具有权限列表中的全部 */
    hasAllPermissions: u,
    /** 用户国家小数使用的分隔符 */
    decimalSeparator: e.dot,
    /** 用户国家小数分割符是否为逗号 */
    thousandSeparator: e.separator,
    /** T10并机站点用户 */
    hasStationMode: S,
    /** ymp站点用户 */
    hasYmpMode: h
  };
}, M = R;
export {
  M as default
};
